<template>
  <GraphiteAlert :variant="alertType" :show="displayAlert">
    {{ message }}
  </GraphiteAlert>
</template>

<script lang="ts" setup>
import {responderConfirmEmail} from "@/composables/responder";
import {getCurrentRoute} from "@/router/util";
import type {Ref} from "vue";
import {onMounted, ref} from "vue";

const displayAlert: Ref<boolean> = ref(false);
const alertType: Ref<"info" | "danger"> = ref("info");
const message: Ref<string> = ref("");

onMounted(async () => {
  const query: Record<string, string> = getCurrentRoute().query as Record<string, string>;

  const responderEmailConfirmation: string = query.responderEmailConfirmation;
  const email: string = query.email;
  const token: string = query.token;

  if (responderEmailConfirmation && email && token) {
    const result = await responderConfirmEmail({email, token});

    if (result.success) {
      alertType.value = "info";
      message.value = result.message;
    } else {
      alertType.value = "danger";
      message.value = result.message || "There was an unknown error confirming your email.";
    }

    displayAlert.value = true;
  }
});

defineOptions({
  compatConfig: {
    MODE: 3,
  },
});
</script>
